module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event/younite-event-ja-8c1f98925d27aef409db001a596df67c.png";